import { Box, Typography, Divider, Grid, Skeleton } from "@mui/material";
import Link from "next/link";
import ReactHtmlParser from 'react-html-parser';
import he from "he";
import { IHelpForRecommend } from "@/interfaces/help";


interface FAQListProps {
    faqs: IHelpForRecommend[];
    loading: Boolean;
    linkMain: string;
}

const FAQList: React.FC<FAQListProps> = ({ faqs, loading, linkMain }) => {

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ mt: 4, fontFamily: "NotoSansThai-SemiBold", fontSize: "24px" }}
                >
                    คำถามที่พบบ่อย
                </Typography>
            </Grid>
            {loading ? (
                <>
                    {
                        Array.from({ length: 6 }).map((_, index) => (
                            <Grid item xs={12} key={index}>
                                <Skeleton variant="rectangular" width="100%" height={50} />
                            </Grid>
                        ))
                    }
                </>
            ) : (
                <Grid item xs={12}>
                    {faqs.map((data: IHelpForRecommend) => (
                        <Link
                            href={`${linkMain}${data.category_slug}/${data.slug}`}
                            key={data.slug}
                            style={{ textDecoration: 'none' }}
                            onMouseOver={(e) => { e.currentTarget.style.color = '#DB5A00'; }}
                            onMouseOut={(e) => { e.currentTarget.style.color = '#292929'; }}
                        >
                            <Box sx={{ mt: 2, mb: 2 }}>
                                <Typography sx={{ mb: 2 }}>
                                    {ReactHtmlParser(he.decode(data.keyword).replace(/<\/?p>/g, ''))}
                                </Typography>
                                <Divider sx={{ mt: 3, mb: 3 }} />
                            </Box>
                        </Link>
                    ))}
                </Grid>
            )}

        </Grid>
    );
};

export default FAQList;
